import { createStore, applyMiddleware, compose, } from 'redux';
import { thunk, } from 'redux-thunk';
import appReducers from './reducers';

const middleware = [ thunk, ];

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line import/no-extraneous-dependencies
  const reduxLogger = require('redux-logger');
  middleware.push(reduxLogger.createLogger());
}

const storedToken = localStorage.getItem('PAYIT_TOKEN');

let authentication;
try {
  authentication = JSON.parse(storedToken || '{}');
} catch {
  // A corrupt entry must not throw here — this runs at module load, and an
  // exception would leave the user with a blank page and no way to recover.
  authentication = {};
}

// An expired token is kept rather than discarded: the refresh cookie can still
// redeem it. SessionBootstrap makes that call at startup and clears the session
// only once a refresh has actually failed.
//
// Boot never starts locked. The lock screen protects work in progress, and a cold
// load has none — raising it here would make the user unlock and then log in.
const initialState = {
  auth: {
    authentication,
    isLocked: false,
  },
};

const enhancer = compose(applyMiddleware(...middleware));
const store = createStore(appReducers, initialState, enhancer);

export default store;
